import React from 'react';
import Tabs from '../../components/Tabs';
import ScheduleItems from './ScheduleItems';

function Schedule({ schedules, config = {} }) {
  const [allSchedules, setAllSchedules] = React.useState(schedules);
  const [filteredSchedules, setFilteredSchedules] = React.useState(schedules);
  const [searchValue, setSearchValue] = React.useState('');
  const [scheduleState, setScheduleState] = React.useState(0);
  const [showTabs] = React.useState(config.show_tabs);

  React.useEffect(() => {
    setAllSchedules(schedules);
    setFilteredSchedules(schedules);
  }, [schedules]);

  const updateSchedule = () => {
    setScheduleState((prev) => prev + 1);
  };

  const applySearch = React.useCallback((value, sourceSchedules = allSchedules) => {
    const normalizedValue = value ? value.toLowerCase() : '';

    return normalizedValue.length > 0
      ? sourceSchedules.filter((s) =>
          (s.title || '').toLowerCase().includes(normalizedValue) ||
          (s.description || '').toLowerCase().includes(normalizedValue)
        )
      : sourceSchedules;
  }, [allSchedules]);

  const handleSearch = (value) => {
    if (value === searchValue) return;

    setSearchValue(value);
    setFilteredSchedules(applySearch(value));
  };

  const handleFavoriteSearch = (value) => {
    if (value === searchValue) return;

    setSearchValue(value);

    const searchedSchedules = applySearch(value);
    setFilteredSchedules(searchedSchedules.filter((s) => s.is_favorite === true));
  };

  return (
    <div>
      {showTabs ? (
        <Tabs
          tabs={[
            {
              label: 'Event schedule',
              content: (
                <ScheduleItems
                  scheduleChanger={updateSchedule}
                  config={config}
                  items={filteredSchedules}
                  onSearch={handleSearch}
                />
              ),
            },
            {
              label: 'My schedule',
              content: (
                <ScheduleItems
                  key={scheduleState}
                  scheduleChanger={updateSchedule}
                  config={config}
                  items={filteredSchedules.filter((f) => f.is_favorite === true)}
                  onSearch={handleFavoriteSearch}
                />
              ),
            }
          ]}
        />
      ) : (
        <ScheduleItems
          scheduleChanger={updateSchedule}
          config={config}
          items={filteredSchedules}
          onSearch={handleSearch}
        />
      )}
    </div>
  );
}

export default Schedule;
